<template>
    <button :title="titleAsString" @click="$emit('click', $event)">
        <slot/>
    </button>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class OtButton extends Vue {

    @Prop() title!: string;

    get titleAsString(): string {
        return this.$t(this.title) as string;
    }

}
</script>
